module.exports = __webpack_public_path__ + "img/slide-14-4.2d902e54.jpg";